import { ApplicationModuleCode } from '@/domain/application-modules/application-module.interface';
import { ApplicationModulesService } from '@/domain/application-modules/application-modules.service';
import { ProfileProvider } from '@/providers/profile/profile.provider';
import { RECOMMENDED_ACTIONS_PAGE_ACCESS } from '@/providers/rights.constants';
import { FeatureCode } from '@/utils/disabled-features/disabled-features.interface';
import { DisabledFeaturesService } from '@/utils/disabled-features/disabled-features.service';
import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RecommendedActionsFeatureService {
    private _router = inject(Router);
    private _profileProvider = inject(ProfileProvider);
    private _disabledFeaturesProvider = inject(DisabledFeaturesService);
    private _applicationModulesProvider = inject(ApplicationModulesService);

    goToFeature() {
        this._router.navigate(['/', 'recommended-actions']);
    }

    hasFeatureAccessR = computed(() => {
        const hasRecommendedActionPageRight = this._profileProvider.hasRightR(RECOMMENDED_ACTIONS_PAGE_ACCESS);
        const isFeatureEnabled = this._disabledFeaturesProvider.isFeatureEnabled(FeatureCode.RECOMMENDED_ACTION);
        const hideToItaly = this._applicationModulesProvider.hasModuleAccessR(ApplicationModuleCode.HIDE_TO_ITALY);

        return hasRecommendedActionPageRight && isFeatureEnabled && !hideToItaly;
    });

    private _hasFeatureAccess$ = toObservable(this.hasFeatureAccessR);

    hasFeatureAccess$() {
        return this._hasFeatureAccess$;
    }

    async hasFeatureAccess(): Promise<boolean> {
        const hasRecommendedActionPageRight = await this._profileProvider.hasRight(RECOMMENDED_ACTIONS_PAGE_ACCESS);
        const isFeatureEnabled = this._disabledFeaturesProvider.isFeatureEnabled(FeatureCode.RECOMMENDED_ACTION);
        const hideToItaly = await this._applicationModulesProvider.hasModuleAccess(ApplicationModuleCode.HIDE_TO_ITALY);
        return hasRecommendedActionPageRight && isFeatureEnabled && !hideToItaly;
    }
}
